import React, { FC, ReactNode } from 'react';
import { DroppableProvided, DroppableStateSnapshot } from 'react-beautiful-dnd';
import { Droppable } from '@prismamedia/one-components';
import { DroppableWrapper } from './DroppableWrapper';

interface BasicDroppableProps {
  droppableId: string;
  droppableType: string;
  droppableKey: string;
  className?: string;
  disableDroppable?: boolean;
  children: ReactNode;
}

export const BasicDroppable: FC<BasicDroppableProps> = ({
  droppableId,
  droppableType,
  droppableKey,
  className = '',
  disableDroppable = false,
  children,
}) => {
  return (
    <Droppable
      droppableId={droppableId}
      type={droppableType}
      key={droppableKey}
      isDropDisabled={disableDroppable}
    >
      {(
        dropProvided: DroppableProvided,
        dropSnapshot: DroppableStateSnapshot,
      ) => (
        <DroppableWrapper
          isDraggingOver={dropSnapshot.isDraggingOver}
          isDraggingFrom={Boolean(dropSnapshot.draggingFromThisWith)}
          innerRef={dropProvided.innerRef}
          className={className}
          {...dropProvided.droppableProps}
        >
          {children}
          {dropProvided.placeholder}
        </DroppableWrapper>
      )}
    </Droppable>
  );
};
